import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { LayoutDashboard } from '../layouts/layout-dashboard';
import { useAxios } from './../hooks/useAxios';

const InvoiceComponent = () => {
  const { id } = useParams();
  const [invoiceKeys, setInvoiceKeys] = useState([]);
  const [invoiceVals, setInvoiceVals] = useState([]);
  const [selectedFile, setSelectedFuile] = useState(null);
  const [uploadResp, setUploadResp] = useState({});
  const { data, error, loading, fetchNow } = useAxios();

  const onFileChange = (e) => {
    setSelectedFuile(e.target.files[0]);
  };

  // On file upload (click the upload button)
  const onFileUpload = () => {
    let payload = {
      name: selectedFile.name,
      file: selectedFile,
      country: 'UA',
      workflow: id,
    };

    /**
     * URL
     * Request method, POST- GET
     * Payload
     * isfile - boolean
     */
    fetchNow(`/api/platform/uploadworkflowfile`, 'POST', payload, true);
  };

  useEffect(() => {
    if (loading) return;
    //   console.log("data in component: ", data);
    if (data?.lineitems) {
      setInvoiceKeys(Object.keys(data));
      setInvoiceVals(Object.values(data));
    } else if (data) {
      setUploadResp(data);
      setInvoiceKeys([]);
      setInvoiceVals([]);
    }
  }, [data, loading]);

  if (error) {
    console.log('error', error);
    return null;
  }

  const grabData = () => {
    const bucketCreds = {
      key: uploadResp.key,
      bucket: uploadResp.bucket,
    };
    fetchNow(`/api/service/extract_data/`, 'POST', bucketCreds);
  };

  return (
    <>
      <LayoutDashboard>
        {uploadResp.url ? (
          <Row>
            <Col>
              uploaded: <img src={uploadResp.url} height={400} alt="" />
            </Col>
          </Row>
        ) : null}
        <Row>
          <Col lg={12} className="p-5">
            <div className="wrapper">
              <div>
                <input type="file" onChange={onFileChange} />
                <button onClick={onFileUpload}>Upload Invoice</button>
                {loading ? 'Loading...' : null}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <button onClick={() => grabData()}>Process Invoice</button>
          </Col>
        </Row>
      </LayoutDashboard>
      <LayoutDashboard>
        {!loading ? (
          <ul>
            {invoiceKeys.map((keyTitle, key) => {
              // this skips the line items
              if (!Array.isArray(invoiceVals[key])) {
                let tittleStr = keyTitle.replace(/([A-Z])/g, ' $1');
                const arr = tittleStr.split(' ');

                for (var i = 0; i < arr.length; i++) {
                  arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
                }
                const formattedLabel = arr.join(' ');

                return (
                  <li key={key}>
                    <p>
                      {formattedLabel} : {invoiceVals[key]}
                    </p>
                  </li>
                );
              } else return null;
            })}
          </ul>
        ) : null}
      </LayoutDashboard>
    </>
  );
};

export { InvoiceComponent };
